// extracted by mini-css-extract-plugin
export default {"container":"NewPost_container__jqVwL","checkboxContainer":"NewPost_checkboxContainer__UHLTI","formContainer":"NewPost_formContainer__zBppp"};